
import React, { useState } from 'react';
import {
    Paper
} from '@mui/material';
import { useTranslation } from "react-i18next";

const DraggableField = ({ field, onDragStart, onDrop }) => {
    const [t] = useTranslation('crm')
    return (
        <Paper
        sx={{
            p: 1, // היה 1.5
            flex: 1,
            minHeight: 40, // היה 50
            fontSize: '0.85rem', // טקסט קטן יותר
            bgcolor: '#f9f9f9',
            cursor: 'grab',
            transition: 'background-color 0.2s',
            '&:hover': {
              bgcolor: '#e3f2fd',
            },
          }}
            draggable
            onDragStart={onDragStart}
            onDragOver={(e) => e.preventDefault()}
            onDrop={onDrop}
        >
            {field?.label || `(${t('Empty')})`}
        </Paper>
    )
}

export default DraggableField